__turbopack_context__.v({
  "onboarding-button-container": "OnboardingMobileLayout-module-scss-module__Qbt2ma__onboarding-button-container",
  "onboarding-button-section": "OnboardingMobileLayout-module-scss-module__Qbt2ma__onboarding-button-section",
  "onboarding-layout": "OnboardingMobileLayout-module-scss-module__Qbt2ma__onboarding-layout",
  "onboarding-progress-bar": "OnboardingMobileLayout-module-scss-module__Qbt2ma__onboarding-progress-bar",
  "onboarding-progress-step": "OnboardingMobileLayout-module-scss-module__Qbt2ma__onboarding-progress-step",
});
